/* Dry Eye Rescue - Homepage behaviours for the der-home-* sections.
   Search suggestions (Shopify Predictive Search API), best-seller carousel,
   count-up stats, scroll reveal. No dependencies. Safe to load once per page. */
(function () {
  'use strict';
  if (window.__derHome) return;
  window.__derHome = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  document.documentElement.classList.add('js');

  function money(cents) {
    var fmt = (window.derHomeMoneyFormat || '${{amount}}');
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Search suggestions ---------- */
  function initSearch(form) {
    var input = form.querySelector('input[type="search"]');
    var list = form.querySelector('.dh-ac');
    if (!input || !list) return;
    var timer = null, lastQ = '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function close() { list.classList.remove('is-open'); list.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); }
    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [], collections = r.collections || [], pages = r.pages || [];
      var html = '';
      if (products.length) {
        html += '<div class="dh-ac__h">Products</div>';
        products.slice(0, 5).forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + '" alt="" loading="lazy">' : '<span style="width:44px;height:44px;border-radius:8px;background:#F5F5F7;flex:none"></span>';
          var vendor = p.vendor ? '<span class="dh-ac__b">' + esc(p.vendor) + '</span>' : '';
          var price = p.price ? '<span class="dh-ac__p">' + esc(money(parseFloat(p.price) * 100)) + '</span>' : '';
          html += '<a class="dh-ac__item" role="option" href="' + esc(p.url) + '">' + img + '<span class="dh-ac__t">' + esc(p.title) + vendor + '</span>' + price + '</a>';
        });
      }
      if (collections.length) {
        html += '<div class="dh-ac__h">Brands and categories</div>';
        collections.slice(0, 4).forEach(function (c) {
          html += '<a class="dh-ac__item dh-ac__item--plain" role="option" href="' + esc(c.url) + '"><span class="dh-ac__t">' + esc(c.title) + '</span></a>';
        });
      }
      if (pages.length) {
        html += '<div class="dh-ac__h">Guides</div>';
        pages.slice(0, 2).forEach(function (pg) {
          html += '<a class="dh-ac__item dh-ac__item--plain" role="option" href="' + esc(pg.url) + '"><span class="dh-ac__t">' + esc(pg.title) + '</span></a>';
        });
      }
      if (!html) html = '<div class="dh-ac__empty">No quick matches. Press Enter to search the full catalog.</div>';
      html += '<a class="dh-ac__all" href="' + root + 'search?type=product&q=' + encodeURIComponent(q) + '">See all results for “' + esc(q) + '” →</a>';
      list.innerHTML = html; list.classList.add('is-open'); input.setAttribute('aria-expanded', 'true');
    }
    function fetchSuggest(q) {
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=5&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku';
      fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (res) { return res.json(); }).then(function (data) { if (q === lastQ) render(q, data); }).catch(function () { close(); });
    }
    input.addEventListener('input', function () {
      var q = input.value.trim(); lastQ = q; clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () { fetchSuggest(q); }, 220);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }
  document.querySelectorAll('.dh-search__form').forEach(initSearch);

  /* Buttons elsewhere on the page can focus the big search */
  document.querySelectorAll('[data-dh-focus-search]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var i = document.querySelector('.dh-search__form input[type="search"]'); if (!i) return;
      e.preventDefault(); i.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); setTimeout(function () { i.focus(); }, 250);
    });
  });
  if (document.querySelector('.dh-mbar')) document.body.classList.add('dh-has-mbar');

  /* ---------- Carousel ---------- */
  function initCarousel(wrap) {
    var track = wrap.querySelector('.dh-prod-grid'), dots = wrap.parentElement.querySelector('.dh-dots');
    if (!track) return;
    var cards = track.children, n = cards.length; if (!n) return;
    var interval = parseInt(wrap.getAttribute('data-interval') || '4000', 10);
    var autoplay = wrap.getAttribute('data-autoplay') !== 'false' && !reduce && !designMode;
    var page = 0, timer = null;
    function per() { return window.innerWidth <= 1100 ? 2 : 4; }
    function pages() { return Math.max(1, Math.ceil(n / per())); }
    function cardW() { return cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 28); }
    function mark() { if (!dots) return; Array.prototype.forEach.call(dots.children, function (d, k) { if (k === page) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); }); }
    function build() {
      if (!dots) return; dots.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to products ' + (i + 1));
        b.addEventListener('click', (function (i) { return function () { go(i, true); }; })(i)); dots.appendChild(b);
      }
      mark();
    }
    function go(i, manual) { page = (i + pages()) % pages(); track.scrollTo({ left: page * per() * cardW(), behavior: reduce ? 'auto' : 'smooth' }); mark(); if (manual) restart(); }
    function start() { if (!autoplay) return; clearInterval(timer); timer = setInterval(function () { go(page + 1); }, interval); }
    function restart() { clearInterval(timer); start(); }
    var prev = wrap.querySelector('.dh-car-btn--prev'), next = wrap.querySelector('.dh-car-btn--next');
    if (prev) prev.addEventListener('click', function () { go(page - 1, true); });
    if (next) next.addEventListener('click', function () { go(page + 1, true); });
    wrap.addEventListener('mouseenter', function () { clearInterval(timer); });
    wrap.addEventListener('mouseleave', start);
    wrap.addEventListener('focusin', function () { clearInterval(timer); });
    wrap.addEventListener('focusout', start);
    track.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
    track.addEventListener('scroll', function () { var p = Math.round(track.scrollLeft / (per() * cardW())); if (p !== page && isFinite(p)) { page = p; mark(); } }, { passive: true });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { build(); go(0); }, 150); });
    build(); start();
  }
  document.querySelectorAll('.dh-carousel').forEach(initCarousel);

  /* ---------- Count-up stats ---------- */
  function initStats(box) {
    var els = box.querySelectorAll('[data-count]'); if (!els.length) return;
    function fmt(v, el) { var s = el.getAttribute('data-nogroup') ? String(Math.round(v)) : Math.round(v).toLocaleString('en-US'); return (el.getAttribute('data-prefix') || '') + s + (el.getAttribute('data-suffix') || ''); }
    function run(el) {
      var to = parseFloat(el.getAttribute('data-count')), from = parseFloat(el.getAttribute('data-from') || '0'), t0 = null, dur = 1400;
      function step(ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / dur); k = 1 - Math.pow(1 - k, 3); el.textContent = fmt(from + (to - from) * k, el); if (k < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }
    if (reduce || designMode || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { els.forEach(run); io.disconnect(); } }); }, { threshold: .4 });
    io.observe(box);
  }
  document.querySelectorAll('.dh-stats').forEach(initStats);


  /* ---------- Lazy video: only download and play the card loops when they are near the viewport ---------- */
  (function () {
    var vids = document.querySelectorAll('video[data-dh-lazy-video]');
    if (!vids.length || reduce) return;
    function play(v) { if (v.dataset.dhStarted) return; v.dataset.dhStarted = '1'; v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { play(e.target); io.unobserve(e.target); } }); }, { rootMargin: '300px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  })();

  /* ---------- Scroll reveal ---------- */
  (function () {
    var els = document.querySelectorAll('.dh-rv,.dh-rv-stagger');
    if (!els.length) return;
    if (reduce || designMode || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: .15, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
    /* Anything still hidden after 3s (e.g. an observer that never fired) becomes visible. */
    setTimeout(function () { els.forEach(function (e) { e.classList.add('is-in'); }); }, 3000);
  })();

  /* Theme editor: re-run when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.dh-search__form').forEach(initSearch);
    e.target.querySelectorAll('.dh-carousel').forEach(initCarousel);
    e.target.querySelectorAll('.dh-rv,.dh-rv-stagger').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
